import React, { forwardRef, useContext, useCallback, ReactElement, useEffect } from 'react';
import clsx from 'clsx';
import { AccordionContext } from './accordion-context';

interface AccordionSummaryProps {
  children?: ReactElement | string;
  className?: string;
  onClick?: (e) => void;
}

const AccordionSummary = forwardRef<HTMLDivElement, AccordionSummaryProps>(function AccordionSummary(
  { children, onClick, className },
  ref
) {
  const {
    disabled = false,
    expanded,
    toggle,
    type,
    expandedIcon,
    unExpandedIcon,
    showExpandIcon,
  } = useContext(AccordionContext);

  const handleClick = useCallback(
    (event) => {
      if (disabled) return;

      toggle && toggle(event);
      onClick && onClick(event);
    },
    [disabled, toggle, onClick]
  );

  const renderExpandIcon = () => {
    if (showExpandIcon) {
      if (expandedIcon && expanded) {
        return expandedIcon;
      }
      if (unExpandedIcon && !expanded) {
        return unExpandedIcon;
      }
      if (!expandedIcon && !unExpandedIcon) {
        return <div className="c-accordion__icon" />;
      }
    }
  };

  return (
    <div
      className={clsx(
        'c-accordion__header',
        expanded && 'c-accordion--active',
        type === 'gray' && 'c-accordion__header--slim c-accordion__header--snow',
        className && className
      )}
      ref={ref}
      onClick={handleClick}
    >
      <div className="c-accordion__title" style={{ width: '100%' }}>
        {children}
      </div>
      {renderExpandIcon()}
    </div>
  );
});

export { AccordionSummary };
